import styled from "@emotion/styled";

export const InputFocusVirtualKeyboardPadding = styled.div`
  label: VirtualKeyboardPadding;
  transition: padding-bottom 0.5s cubic-bezier(0.38, 0.7, 0.125, 1);

  &:has(:focus-within) {
    padding-bottom: var(--stored-keyboard-height, 0px);
  }
`;
